import { useLoaderData } from "@remix-run/react";
import BlogBox from "~/components/blog/BlogBox";
import { loader } from "./route";
import { useTranslation } from "react-i18next";
import * as BlogBoxSvgs from "~/svgs/BlogBoxSvgs";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import X from "~/svgs/footer/X";

export default function ArticleOrCaseStudy() {
  const { blog, locale } = useLoaderData<typeof loader>();
  const { t } = useTranslation("blog");

  const [pageLink, setPageLink] = useState("");

  useEffect(() => {
    setPageLink(window.location.href);
  }, []);

  return (
    <>
      <BlogBox
        blog={blog}
        imgRatio="aspect-square sm:aspect-[8/3]"
        className=""
        locale={locale}
        page={true}
      />
      <div className="mt-9 flex gap-3">
        <div
          className="flex cursor-pointer items-center gap-2 rounded-md bg-Secondary-Dark-Blue-db-50 px-3 py-2 text-sm font-semibold text-Secondary-Dark-Blue-db-300"
          onClick={() => {
            navigator.clipboard.writeText(window.location.href).then((res) => {
              toast.success(t("copied"));
            });
            // check if copied
          }}
        >
          <BlogBoxSvgs.Copy />
          <span className="text-nowrap">{t("copy")}</span>
        </div>
        <a
          href={
            "https://www.linkedin.com/shareArticle?mini=true&url=" + pageLink
          }
          target="_blank"
        >
          <BlogBoxSvgs.LinkedIn />
        </a>
        <a
          href={"https://www.facebook.com/sharer/sharer.php?u=" + pageLink}
          target="_blank"
        >
          <BlogBoxSvgs.Facebook />
        </a>
        <a href={"https://x.com/intent/post?url=" + pageLink} target="_blank">
          <BlogBoxSvgs.X />
        </a>
        <a href={"whatsapp://send?text=" + pageLink} target="_blank">
          <BlogBoxSvgs.Whatsapp />
        </a>
      </div>
    </>
  );
}
